import Carousel from "bootstrap/js/dist/carousel";

export default function carouselsInit() {
    const carousels = document.querySelectorAll(".carousel");
    if (!carousels.length) return;

    carousels.forEach((carouselEl) => {
        const carousel = Carousel.getOrCreateInstance(carouselEl);
        const btn = carouselEl.querySelector(".carousel-pause-play-btn");
        const icon = btn?.querySelector(".bi");
        const carouselInner = carouselEl.querySelector(".carousel-inner");
        const autoPlay = carouselEl.dataset.saSlide === "auto";

        // Nothing to do if this carousel doesn't autoplay
        if (!autoPlay || !btn) {
            carouselInner.setAttribute("aria-live", "polite");
            return;
        }

        btn.hidden = false;
        let playing = true;

        // Respect reduced motion preference
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
            carousel.pause();

            playing = false;

            btn.setAttribute("aria-pressed", "true");
            btn.setAttribute("aria-label", "Play carousel");

            icon.classList.replace("bi-pause", "bi-play");

            carouselInner.setAttribute("aria-live", "polite");
        } else {
            carousel.cycle();
            carouselInner.setAttribute("aria-live", "off");
        }

        btn.addEventListener("click", () => {
            playing = !playing;

            if (playing) {
                carousel.cycle();

                btn.setAttribute("aria-pressed", "false");
                btn.setAttribute("aria-label", "Pause carousel");

                icon.classList.replace("bi-play", "bi-pause");

                carouselInner.setAttribute("aria-live", "off");
            } else {
                carousel.pause();

                btn.setAttribute("aria-pressed", "true");
                btn.setAttribute("aria-label", "Play carousel");

                icon.classList.replace("bi-pause", "bi-play");

                carouselInner.setAttribute("aria-live", "polite");
            }
        });

        // If auto-playing, keep cycling even if user interacts with navigation or hovers(pause)
        carouselEl.addEventListener("slid.bs.carousel", () => playing && carousel.cycle());
        carouselEl.addEventListener("mouseleave", () => playing && carousel.cycle());
    });
}
